import { render, staticRenderFns } from "./ChatCall.vue?vue&type=template&id=c8a73296"
import script from "./ChatCall.vue?vue&type=script&lang=js"
export * from "./ChatCall.vue?vue&type=script&lang=js"
import style0 from "./ChatCall.vue?vue&type=style&index=0&id=c8a73296&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports